import getActionsByDocument from '../../../../../components/comments/actions';

const DOCUMENT = 'DIVISION_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
